export const marketSelector = {
  en: {
    heading: "{country} store",
    detected: "We detected you're browsing from",
    goTo: "Go to {country} store",
    continueOn: "Continue on {country} store",
    shippingNote:
      "Ordering from the wrong store may not allow shipping to your region.",
    closeAria: "Close store selector",
    // Split region/language pill aria-labels. {value} = the current region or
    // language label (already formatted, e.g. "Germany (€)" / "Deutsch").
    regionAria: "Region: {value}",
    languageAria: "Language: {value}",
    // Popup listbox aria-labels.
    chooseLanguage: "Choose language",
    regionAndLanguage: "Region and language",
    // Region-selector trigger aria-label. {current} = "<country>, <currency>".
    changeMarketAria: "Change market — current: {current}",
    // Region-selector dropdown menu aria-label.
    selectMarketAria: "Select market",
  },
  de: {
    heading: "{country}-Shop",
    detected: "Wir haben erkannt, dass du dich hier befindest:",
    goTo: "Zum {country}-Shop",
    continueOn: "Im {country}-Shop bleiben",
    shippingNote:
      "Bestellungen im falschen Shop können unter Umständen nicht in deine Region geliefert werden.",
    closeAria: "Shop-Auswahl schließen",
    regionAria: "Region: {value}",
    languageAria: "Sprache: {value}",
    chooseLanguage: "Sprache auswählen",
    regionAndLanguage: "Region und Sprache",
    changeMarketAria: "Markt ändern – aktuell: {current}",
    selectMarketAria: "Markt auswählen",
  },
} as const
